export default __webpack_public_path__ + "static/media/book-demo.c228a859.webp";